import { StatTile } from '@/components/patterns/StatTile'
import { agreementsHref, relationsHref, staleHref } from './links'
import { plural } from './text'
import type { Kpis, Scope } from './types'


/** Widget 1: the five key figures (design §4.1). Each tile opens the matching view; "Deze week" shows the agenda's week. */
export function KpiRow({ kpis, scope, onShowWeek }: { kpis: Kpis; scope: Scope; onShowWeek: () => void }) {
  const week = kpis.this_week
  const stale = kpis.stale
  const weekParts = [plural(week.tasks, 'taak', 'taken')]
  if (week.deadlines > 0) weekParts.push(plural(week.deadlines, 'deadline', 'deadlines'))
  weekParts.push(plural(week.events, 'event', 'events'))
  return (
    <section aria-label="Kerncijfers" className="grid grid-cols-2 gap-3 md:grid-cols-3 xl:grid-cols-5">
      <StatTile
        label="Actieve relaties"
        value={kpis.relations.persons + kpis.relations.organisations}
        subParts={[plural(kpis.relations.persons, 'persoon', 'personen'), `${kpis.relations.organisations} org.`]}
        definition="Personen en organisaties"
        to={relationsHref(scope)}
      />
      <StatTile
        label="Actieve afspraken"
        value={kpis.agreements.active}
        subParts={[`${kpis.agreements.with_rhythm} ritme`, `${kpis.agreements.active - kpis.agreements.with_rhythm} overig`]}
        definition="Lopende afspraken"
        to={agreementsHref(scope)}
      />
      <StatTile
        label="Deze week"
        value={week.tasks + week.deadlines + week.events}
        subParts={weekParts}
        definition="Tot en met zondag"
        onClick={onShowWeek}
      />
      <StatTile
        label="Achterstallig"
        value={kpis.overdue}
        tone="danger"
        subParts={[`${kpis.overdue_from_agreements} uit afspraken`]}
        definition="Open taken over datum"
        to={agreementsHref(scope, 'sys:achterstallig')}
      />
      <StatTile
        label="Te lang stil"
        value={stale.persons + stale.organisations}
        subParts={[plural(stale.persons, 'persoon', 'personen'), `${stale.organisations} org.`]}
        definition="> 90 dagen zonder contact"
        to={staleHref(scope)}
      />
    </section>
  )
}
